import '@ui5/webcomponents-fiori/dist/Bar.js';
import { BarDesign } from '../../enums';
import { withWebComponent } from '../../internal/withWebComponent';
/**
 * The Bar is a container which is primarily used to hold titles, buttons and input elements and its design and functionality is the basis for page headers and footers. The component consists of three areas to hold its content - startContent slot, default slot and endContent slot. It has the capability to center content, such as a title, while having other components on the left and right side.
 *
 * <ui5-link href="https://sap.github.io/ui5-webcomponents/playground/components/Bar" target="_blank">UI5 Web Components Playground</ui5-link>
 */
const Bar = withWebComponent('ui5-bar', ['design'], [], ['endContent', 'startContent'], []);
Bar.displayName = 'Bar';
Bar.defaultProps = {
    design: BarDesign.Header
};
export { Bar };
